/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ list: NonNullable<unknown> }} Partner_Org_Contract_Approve_AddonsInputs */



/**
* | output |
* | --- |
* | "Included in the contract, fixed for the term: {list}." |
*
* @param {Partner_Org_Contract_Approve_AddonsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_approve_addons = /** @type {((inputs: Partner_Org_Contract_Approve_AddonsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Approve_AddonsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Im Vertrag enthalten, fest für die Laufzeit: ${i?.list}.`)
	return /** @type {LocalizedString} */ (`Included in the contract, fixed for the term: ${i?.list}.`)
});